import { gql } from "@apollo/client";

const ACCEPT_NOMINATION = gql`
mutation AcceptNomination($id: String){
    acceptNomination(id: $id)
    }
`;

export default ACCEPT_NOMINATION;
